import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Property } from '@vsolv/packages/properties/domain';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-property-badge',
  templateUrl: './property-badge.component.html',
  standalone: false,
})
export class PropertyBadgeComponent {
  @Input() property!: Property.Model<Property.PropertyType>;
  @Input() showHidden = true;
}
